// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2c5uM","title":"Header_title__WnAia","left":"Header_left__MHQyL","clinicName":"Header_clinicName__3QISK"};